import { render, staticRenderFns } from "./OCheckBoxInput.vue?vue&type=template&id=9b5aa276&scoped=true&"
import script from "./OCheckBoxInput.vue?vue&type=script&lang=js&"
export * from "./OCheckBoxInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5aa276",
  null
  
)

export default component.exports